import { ResourceGlobal } from "./ResourceGlobal";
import { ResourceRegional } from "./ResourceRegional";
import { ResourceRegionalUsOnly } from "./ResourceRegionalUsOnly";

export const Resource = {
  ...ResourceGlobal,
  ...ResourceRegional,
  ...ResourceRegionalUsOnly,
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Resource =
  ResourceGlobal | ResourceRegional | ResourceRegionalUsOnly;

const RESOURCE_VALUES = new Set<string>(Object.values(Resource));

export function isResource(value: string): value is Resource {
  return RESOURCE_VALUES.has(value);
}
